import useSWR, { SWRResponse } from 'swr'
import { fetcherExternal } from 'common-code-react/utils/fetcherExternal'
import { MoreInfo } from 'common-code-react/common-types/upr/moreInfo'

export function useMoreInfo(url: string | undefined): SWRResponse<MoreInfo> {
  return url ? useSWR(url, fetcherExternal()) : useSWR(null)
}
